export default {"src":"/_next/static/media/curious.1a123a6e.svg","height":232,"width":260};